/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_ChemistryInputs */

const en_onboarding_genre_chemistry = /** @type {(inputs: Onboarding_Genre_ChemistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemistry`)
};

const es_onboarding_genre_chemistry = /** @type {(inputs: Onboarding_Genre_ChemistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Química`)
};

/**
* | output |
* | --- |
* | "Chemistry" |
*
* @param {Onboarding_Genre_ChemistryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_chemistry = /** @type {((inputs?: Onboarding_Genre_ChemistryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_ChemistryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_chemistry(inputs)
	return en_onboarding_genre_chemistry(inputs)
});